import * as types from './mutations-types'

export const reset = function ({commit}) {
  commit(types.SET_ACTIVE_MENU_INDEX, '')
  commit(types.SET_USER_ACTIVE_MENU_INDEX, '')
  commit(types.SET_MESSAGE_NUMBER, 0)
}



// WEBPACK FOOTER //
// ./src/store/actions.js